'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import * as React from 'react';
import styled from 'styled-components';
import classNames from 'classnames';
import UIMediaObject from '../layout/UIMediaObject';
import UITruncateString from '../text/UITruncateString';
import memoizeOne from 'react-utils/memoizeOne';
import { Consumer as FieldsetContextConsumer } from '../context/FieldsetContext';
import { warnIfFragment } from '../utils/devWarnings';
const LABEL_SIZE_OPTIONS = {
  default: '',
  small: 'private-input-static-label--small'
};

const getStyledLabelWrapper = (Component, className) => styled(Component).attrs({
  className
}).withConfig({
  displayName: "UIInputStaticLabel__getStyledLabelWrapper",
  componentId: "sc-184apyb-0"
})(["max-width:50%;"]);

class UIInputStaticLabel extends React.Component {
  constructor(props) {
    super(props);
    this._getStyledLabelWrapper = memoizeOne(getStyledLabelWrapper);
  }

  render() {
    const _this$props = this.props,
          {
      children,
      className,
      id,
      labelWrapperClassName,
      position,
      text,
      error
    } = _this$props,
          rest = _objectWithoutPropertiesLoose(_this$props, ["children", "className", "id", "labelWrapperClassName", "position", "text", "error"]);

    return /*#__PURE__*/_jsx(FieldsetContextConsumer, {
      children: ({
        size: fieldSize
      }) => {
        const computedClassName = classNames('private-input-static-label', className, LABEL_SIZE_OPTIONS[fieldSize]);

        const renderedLabel = /*#__PURE__*/_jsx(UITruncateString, {
          useFlex: true,
          className: "private-input-static-label__label",
          children: text
        });

        const cloneProps = {
          id: children.props.id || id
        }; // avoid "unknown prop" warning when `error` is undefined

        if (error !== undefined) {
          cloneProps.error = error;
        }

        const onlyChild = React.Children.only(children);
        warnIfFragment(onlyChild, UIInputStaticLabel.displayName);
        return /*#__PURE__*/_jsx("label", Object.assign({}, rest, {
          className: computedClassName,
          children: /*#__PURE__*/_jsx(UIMediaObject, {
            spacing: "extra-small",
            itemLeft: position === 'start' ? renderedLabel : undefined,
            MediaLeft: this._getStyledLabelWrapper(UIMediaObject.defaultProps.MediaLeft, labelWrapperClassName),
            itemRight: position === 'end' ? renderedLabel : undefined,
            MediaRight: this._getStyledLabelWrapper(UIMediaObject.defaultProps.MediaRight, labelWrapperClassName),
            children: /*#__PURE__*/React.cloneElement(onlyChild, cloneProps)
          })
        }));
      }
    });
  }

}

UIInputStaticLabel.propTypes = {
  children: PropTypes.element.isRequired,
  labelWrapperClassName: PropTypes.string,
  position: PropTypes.oneOf(['start', 'end']).isRequired,
  text: PropTypes.node.isRequired,
  error: PropTypes.bool
};
UIInputStaticLabel.defaultProps = {
  position: 'start'
};
UIInputStaticLabel.displayName = 'UIInputStaticLabel';
export default UIInputStaticLabel;